
// Sound effect utility for consistent audio handling

export const sounds = {
  like: () => {
    const audio = new Audio('/sounds/like.mp3');
    audio.volume = 0.7;
    return audio.play().catch(err => console.error('Failed to play sound:', err));
  },
  post: () => {
    const audio = new Audio('/sounds/post.mp3');
    audio.volume = 0.7;
    return audio.play().catch(err => console.error('Failed to play sound:', err));
  },
  delete: () => {
    const audio = new Audio('/sounds/delete.mp3');
    audio.volume = 0.6;
    return audio.play().catch(err => console.error('Failed to play sound:', err));
  },
  error: () => {
    const audio = new Audio('/sounds/error.mp3');
    audio.volume = 0.6;
    return audio.play().catch(err => console.error('Failed to play sound:', err));
  },
  success: () => {
    const audio = new Audio('/sounds/success.mp3');
    audio.volume = 0.6;
    return audio.play().catch(err => console.error('Failed to play sound:', err));
  }
};
